"use strict";

module.exports = function isObject(x) {
	return typeof x === "object" && x !== null;
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/is-object/index.js
 ** module id = 401
 ** module chunks = 0
 **/